export class AgroScheliveError extends Error {
  readonly code: string
  readonly details?: unknown

  constructor(code: string, message: string, details?: unknown) {
    super(message)
    this.name = 'AgroScheliveError'
    this.code = code
    this.details = details
  }
}

export const ERROR_CODES = {
  invalidOfflineUpdate: 'INVALID_OFFLINE_UPDATE',
  unsupportedOfflineType: 'UNSUPPORTED_OFFLINE_TYPE',
  invalidEnvironment: 'INVALID_ENVIRONMENT',
  authenticationError: 'AUTHENTICATION_ERROR',
  uploadError: 'UPLOAD_ERROR',
  syncError: 'SYNC_ERROR',
} as const

export function createOfflineTypeError(type: string) {
  return new AgroScheliveError(
    ERROR_CODES.unsupportedOfflineType,
    `Tipo offline nao suportado: ${type}`,
    { type }
  )
}

export function createInvalidOfflineUpdateError(reason: string) {
  return new AgroScheliveError(
    ERROR_CODES.invalidOfflineUpdate,
    `Atualizacao offline invalida: ${reason}`,
    { reason }
  )
}
